'use client'

import React, { createContext, useContext } from 'react'

import { Config, NextjsConfig } from './types'

export * from './types'

export const defaultConfig: Config = {
  nextjs: false,
  imageHost: undefined,
}

export const defaultNextjsConfig: NextjsConfig = {
  disableImageOptimization: false,
  disableNextImage: false,
  disableNextLink: false,
}

const ConfigContext = createContext(defaultConfig)

export const useConfig = (): Omit<Config, 'nextjs'> & {
  nextjs: NextjsConfig | false
} => {
  const config = useContext(ConfigContext)

  return React.useMemo(
    () => ({
      ...config,
      nextjs: config.nextjs
        ? config.nextjs === true
          ? defaultNextjsConfig
          : { ...defaultNextjsConfig, ...config.nextjs }
        : false,
    }),
    [config],
  )
}

export interface ConfigProviderProps {
  config?: Config
  children: React.ReactNode
}

export const ConfigProvider = ({
  config,
  children,
}: ConfigProviderProps): React.ReactNode => {
  const value = React.useMemo(() => ({ ...defaultConfig, ...config }), [config])

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  )
}
